import { useRef, useState } from "react";
import api from "../api";
import { toast } from "sonner";
import { Camera, RefreshCw, Trash2, Loader2 } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const OK = ["jpg", "jpeg", "png", "webp"];

export default function PhotoManager({ apartmentId, imageUrl, onChange }) {
  const inputRef = useRef();
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState(null);
  const [drag, setDrag] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    const ext = file.name.split(".").pop().toLowerCase();
    if (!OK.includes(ext)) return toast.error("Usa JPG, PNG o WEBP");
    const localUrl = URL.createObjectURL(file);
    setPreview(localUrl);
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      await api.post(`/apartments/${apartmentId}/photo`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Foto principale aggiornata"); setPreview(null); onChange?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore upload"); setPreview(null); }
    finally { setBusy(false); URL.revokeObjectURL(localUrl); }
  };
  const onDrop = (e) => { e.preventDefault(); setDrag(false); upload(e.dataTransfer.files?.[0]); };
  const del = async () => {
    if (!window.confirm("Eliminare la foto principale?")) return;
    try { await api.delete(`/apartments/${apartmentId}/photo`); setPreview(null); toast.success("Foto eliminata"); onChange?.(); }
    catch { toast.error("Errore"); }
  };

  const src = preview || (imageUrl ? `${BACKEND}${imageUrl}` : null);

  return (
    <div className="relative" data-testid="photo-manager">
      <input ref={inputRef} type="file" accept=".jpg,.jpeg,.png,.webp" className="hidden" data-testid="photo-input"
        onChange={(e) => { upload(e.target.files?.[0]); e.target.value = ""; }} />
      {src ? (
        <div className="group relative h-16 w-24 overflow-hidden rounded-lg border border-slate-200">
          <img src={src} alt="Foto principale" className="h-full w-full object-cover" data-testid="photo-preview" />
          <div className="absolute inset-0 flex items-center justify-center gap-1 bg-black/50 opacity-0 transition-opacity group-hover:opacity-100">
            {busy ? <Loader2 size={16} className="animate-spin text-white" /> : (
              <>
                <button data-testid="photo-replace" onClick={() => inputRef.current?.click()} className="rounded-md bg-white/90 p-1.5 text-slate-700 hover:bg-white"><RefreshCw size={13} /></button>
                <button data-testid="photo-delete" onClick={del} className="rounded-md bg-white/90 p-1.5 text-rose-600 hover:bg-white"><Trash2 size={13} /></button>
              </>
            )}
          </div>
        </div>
      ) : (
        <button data-testid="photo-upload-zone" onClick={() => inputRef.current?.click()}
          onDragOver={(e) => { e.preventDefault(); setDrag(true); }} onDragLeave={() => setDrag(false)} onDrop={onDrop}
          className={`flex h-16 w-24 flex-col items-center justify-center gap-1 rounded-lg border-2 border-dashed text-[10px] transition-colors ${drag ? "border-primary bg-primary/5 text-primary" : "border-slate-300 text-slate-400 hover:border-primary hover:text-primary"}`}>
          {busy ? <Loader2 size={16} className="animate-spin" /> : <><Camera size={16} /> Carica foto</>}
        </button>
      )}
    </div>
  );
}
